import { ColorRow } from "../../formulation/models/color-row";

export class ColorByContrastCriteria {
    colorVariantIdToContrastColor: number;
    color: ColorRow;
}
